import { render } from "./Dashboard.vue?vue&type=template&id=4b11728a"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\IanFlew\\Documents\\Projects\\Fleetcare Configurator\\fleetcare-configurator-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__